import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Media API functions
export const uploadMedia = async (file, index = 1, name = '', isShowInList = true) => {
  const finalName = name || file?.name || '';
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', file.type);
  formData.append('size', file.size);
  formData.append('isShowInList', isShowInList);
  formData.append('name', finalName);
  formData.append('index', index);

  try {
    const response = await axiosInstance.post(API_ROUTES.MEDIA.UPLOAD, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data?.data || {};
  } catch (error) {
    console.log({error})
    console.error('Upload failed:', error.response?.data || error.message);
    throw error;
  }
};

export const getAllMedia = async (queryParams = {}) => {
  try {
    const params = {
      search: queryParams.search || '',
      date: queryParams.date || ''
    };
    const response = await axiosInstance.get(API_ROUTES.MEDIA.GET, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching product brands:', error);
    throw error;
  }
};

export const getAllMediaDates = async () => {
  try {
    const response = await axiosInstance.get(API_ROUTES.MEDIA.GETDATE);
    return response.data;
  } catch (error) {
    console.error('Error fetching product brands:', error);
    throw error;
  }
};

export const updateMedia = async (id, data) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.MEDIA.UPDATE}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating media:', error);
    throw error;
  }
};

export const deleteMedia = async (ids) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.MEDIA.DELETE, { data: { ids } });
    return response.data;
  } catch (error) {
    console.error('Error deleting media:', error);
    throw error;
  }
};

// Additional functions can be added here as needed